import { render, staticRenderFns } from "./TaskAssignments.vue?vue&type=template&id=3a4ef2f4&scoped=true&"
import script from "./TaskAssignments.vue?vue&type=script&lang=js&"
export * from "./TaskAssignments.vue?vue&type=script&lang=js&"
import style0 from "./TaskAssignments.vue?vue&type=style&index=0&id=3a4ef2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ef2f4",
  null
  
)

export default component.exports